// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IsYL","col":"styles_col__1Jd9X","actions":"styles_actions__256D-","conflict":"styles_conflict__2V6q4"};